import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { isExternalUrl, stripDomainAndProtocalFromUrl } from "../../utilities/urlHelper";
import Sparkle from "../icons/sparkle";

/**
 * DonateMonthlyButton component, specialized donation button for "Donate monthly" actions
 * @param {*} buttonProps
 * @returns
 */
const DonateMonthlyButton = ({ href, text = "Donate monthly" }) => {
  const isExternal = isExternalUrl(href) ?? true;
  const [sanitisedHref, setSanitisedHref] = useState(href);

  useEffect(() => {
    if (!isExternal) {
      const cleanUrl = stripDomainAndProtocalFromUrl(href);
      setSanitisedHref(cleanUrl.startsWith("/") ? cleanUrl : "/" + cleanUrl);
    }
  }, [href, isExternal]);

  const starElements = (
    <>
      <Sparkle className="star-1 star" />
      <Sparkle className="star-2 star" />
      <Sparkle className="star-3 star" />
      <Sparkle className="star-4 star" />
      <Sparkle className="star-5 star" />
    </>
  );

  const hoverElement = (
    <div className="btn-donate-monthly-hover-wrapper">
      <svg width="628" height="126" viewBox="0 0 628 126" fill="none" xmlns="http://www.w3.org/2000/svg" className="btn-donate-monthly-hover">
        <g clipPath="url(#clip0_104_22)">
          <path
            d="M621.79 42.89L587.2 40.96C584.65 40.83 582.44 39.19 581.52 36.82L568.94 4.18C566.81 -1.4 558.88 -1.34 556.81 4.27L544.83 36.61C543.93 39.04 541.67 40.7 539.07 40.85L504.8 42.54C498.87 42.85 496.45 50.28 501.02 54.03L528.16 76.25C530.09 77.84 530.97 80.44 530.33 82.89L521.6 116.86C520.12 122.59 526.49 127.14 531.46 123.89L560.09 104.99C562.26 103.55 565.05 103.56 567.23 104.99L596.05 123.97C601.03 127.25 607.44 122.61 605.87 116.85L596.7 83.1C596.04 80.64 596.88 78.01 598.84 76.39L625.59 54.37C630.15 50.62 627.71 43.23 621.84 42.91H621.79V42.89Z"
            fill="#52288E"
          />
          <path d="M528 125H0L41 0H563L528 125Z" fill="#52288E" />
        </g>
        <defs>
          <clipPath id="clip0_104_22">
            <rect width="627.96" height="125.05" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );

  return isExternal ? (
    <a href={sanitisedHref} className="btn-donate-monthly" target="_blank" rel="noopener noreferrer">
      <span className="btn-donate-monthly-text">{text}</span>
      {starElements}
      {hoverElement}
    </a>
  ) : (
    <Link to={sanitisedHref} className="btn-donate-monthly">
      <span className="btn-donate-monthly-text">{text}</span>
      {starElements}
      {hoverElement}
    </Link>
  );
};

export default DonateMonthlyButton;
